module.exports = __webpack_public_path__ + "img/login-bg.88b41ae4.jpg";